export interface ISearchModeField {
  key: string;
  label: string;
}

export interface ISearchModeConfig {
  key: string;
  simpleFields: ISearchModeField[];
  advancedFields: ISearchModeField[];
}

export const clientsSearchModeConfig: ISearchModeConfig = {
  key: "clients",
  simpleFields: [
    { key: "companyName", label: "Nazwa firmy" },
    { key: "shortName", label: "Skrót" },
    { key: "city", label: "Miasto" },
    { key: "street", label: "Ulica" },
    { key: "postalCode", label: "Kod pocztowy" },
    { key: "taxNumber", label: "NIP" },
    { key: "bdoNumber", label: "BDO" },
  ],
  advancedFields: [
    { key: "vatStatus", label: "Status VAT" },
    { key: "verified", label: "Weryfikacja" },
    { key: "multiDepartment", label: "Wielooddziałowość" },
    { key: "deactivationReason", label: "Powód dezaktywacji" },
    { key: "orderTypes", label: "Typy zamówień" },
    { key: "source", label: "Źródło" },
  ],
};

export const ordersSearchModeConfig: ISearchModeConfig = {
  key: "orders",
  simpleFields: [
    { key: "number", label: "Numer zamówienia" },
    { key: "company", label: "Klient" },
    { key: "city", label: "Miejscowość" },
    { key: "street", label: "Ulica" },
    { key: "postalCode", label: "Kod pocztowy" },
    { key: "cuoOrderNumber", label: "Numer CUO" },
  ],
  advancedFields: [
    { key: "createdAt", label: "Data zamówienia" },
    { key: "acceptedDate", label: "Data przyjęcia" },
    { key: "type", label: "Typ zamówienia" },
    { key: "quantity", label: "Ilość" },
    { key: "contactPhone", label: "Telefon kontaktowy" },
    { key: "vehicleBrand", label: "Marka pojazdu" },
    { key: "vehicleModel", label: "Model pojazdu" },
    { key: "vehicleRegistration", label: "Rejestracja pojazdu" },
    { key: "orderTypeItemName", label: "Typ pozycji" },
    { key: "orderTypeItemValue", label: "Wartość pozycji" },
    { key: "operator", label: "Operator" },
    { key: "invoiceNumber", label: "Numer faktury" },
    { key: "optimaNumber", label: "Numer Optima" },
    { key: "internalStoreName", label: "Magazyn wewnętrzny" },
    { key: "internalStoreDistance", label: "Dystans do magazynu" },
    { key: "source", label: "Źródło" },
  ],
};